import ApiService from '@/services/api.service'

const SuperBillService = {

    getSuperBillLookup(params) {
        const requestData = {
            method: 'get',
            url: '/SuperBills/LookUp',
            params: params
        };

        return ApiService.customRequest(requestData);
    }
}

export default SuperBillService;
